import { createFileRoute } from '@tanstack/react-router';
import { FormListPage } from '@/pages/forms/FormListPage';

export const Route = createFileRoute('/_authenticated/_app/forms/')({
	component: FormListPage,
});
